import Backdrop from '@mui/material/Backdrop'
import CircularProgress from '@mui/material/CircularProgress'
import * as React from 'react'
import { palette } from 'src/theme/palette'

export function Spinner(): JSX.Element {
  const [open, setOpen] = React.useState(false)
  React.useEffect(() => {
    setOpen(true)
  }, [open])

  const handleClose = (): void => {
    setOpen(false)
  }
  return (
    <Backdrop
      sx={{
        zIndex: 99999,
      }}
      open={open}
      onClick={handleClose}
      transitionDuration={2000}
    >
      <CircularProgress sx={{ color: palette.primary.main }} />
    </Backdrop>
  )
}
